import { Component, type CSSStyleSpecDeclaration } from "@bodil/dom/component";
import { html } from "lit";
import { customElement } from "lit/decorators.js";

import styles from "./stack-page.css?inline";

declare global {
    interface HTMLElementTagNameMap {
        "btk-stack-page": BtkStackPage;
    }
}

@customElement("btk-stack-page")
export class BtkStackPage extends Component {
    protected override render(): unknown {
        return html`<div part="content" id="content"><slot></slot></div>`;
    }

    static styles: CSSStyleSpecDeclaration = styles;
}
